import { OpenIdConnectService } from '@services/auth/open-id-connect.service';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { PermissionsService } from '@services/auth/permissions.service';

@Injectable({ providedIn: 'root' })
export class RequireAuthenticatedUserRouteGuardService  {
  constructor(
    private openIdConnectService: OpenIdConnectService,
    private router: Router,
    private permissions: PermissionsService
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.openIdConnectService.userAvailable) {
      if (this.permissions.getPermission(next.data.section) !== 'N') {
        return true;
      } else {
        // this.router.navigate([{ outlets: { [next.outlet]: ['401'] } }]);
        console.error('Unable to obtain permissions for user', `Section : ${next.data.section}`);
        window.location.href = '/401';
        return false;
      }
    } else {
      this.openIdConnectService.triggerSignIn();
      return false;
    }
  }
}
